export enum PostVisibility {
  draft = 'draft',
  published = 'published',
  locked = 'locked',
  drip = 'drip',
}

export enum PostContentType {
  quiz = 'quiz',
  assignment = 'assignment',
  video = 'video',
  audio = 'audio',
  embed = 'embed',
  text = 'text',
  funnel = 'funnel',
}

export enum TreeNodeType {
  post = 'post',
  category = 'category',
}

export enum QuizSubmissionStatus {
  passed = 'passed',
  failed = 'failed',
  processing = 'processing',
}

export enum QuizTypes {
  graded = 'graded',
  ungraded = 'ungraded',
}

export enum OfferType {
  free = 'free',
  oneTime = 'onetime',
  subscription = 'subscription',
  multiple = 'multiple',
}

export enum PostGeneralStatus {
  completed = 'completed',
  drip = 'drip',
  locked = 'locked',
  partiallyCompleted = 'partially-completed',
}
